var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenbike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 387,
    viewBox: "0 0 172 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.661 182.56C170.142 186.073 171.459 190.275 171.427 194.575C171.262 215.807 167.167 236.298 161.961 259.855C160.932 256.913 158.859 254.451 156.136 252.935C153.413 251.418 150.229 250.952 147.185 251.625C145.127 235.455 144.469 220.189 146.177 206.816C141.108 205.563 136.163 203.855 131.401 201.714C126.284 191.185 121.971 180.284 118.498 169.105C107.986 165.804 97.0929 163.868 86.0868 163.344C75.0742 163.87 64.1745 165.806 53.6547 169.105C50.1981 180.287 45.8915 191.188 40.7724 201.714C36.0106 203.855 31.0653 205.563 25.9968 206.816C27.7048 220.189 26.964 235.455 24.9884 251.625C21.945 250.952 18.7603 251.418 16.0374 252.935C13.3144 254.451 11.2421 256.913 10.2129 259.855C5.00647 236.298 0.911276 215.807 0.746646 194.575C0.715142 190.275 2.03212 186.073 4.51253 182.56C12.4948 171.061 21.8829 160.604 32.4585 151.432L37.3563 146.947C52.9392 140.915 69.395 137.441 86.0868 136.66C102.772 137.439 119.222 140.913 134.797 146.947L139.715 151.432C150.291 160.604 159.679 171.061 167.661 182.56V182.56Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.103 139.211C164.987 142.746 159.904 144.961 154.512 145.568C150.569 145.863 146.65 144.74 143.462 142.4C141.013 140.775 138.193 134.706 135.333 128.842L133.11 114.338L132.699 99.8128L134.016 89.526L128.871 104.565L126.669 106.767C128.415 110.644 129.56 114.765 130.065 118.987C130.074 125.4 128.808 131.75 126.34 137.668C113.027 135.7 99.5869 134.717 86.1291 134.726V134.726C72.6871 134.692 59.2609 135.648 45.9593 137.586C43.4914 131.667 42.2253 125.317 42.2346 118.905C42.7278 114.681 43.8733 110.558 45.63 106.684L43.4076 104.483L38.2834 89.4437L39.6005 99.7305L39.1889 114.255L36.9664 128.76C34.106 134.623 31.2867 140.693 28.7349 142.318C25.5573 144.663 21.6425 145.787 17.7046 145.486C12.3082 144.875 7.21888 142.661 3.09375 139.129C4.62744 128.89 7.5346 118.904 11.7368 109.441C11.1773 106.727 11.1773 103.926 11.7368 101.212C13.1745 98.6209 14.7689 96.1199 16.5111 93.723C16.1131 87.3682 16.389 80.9891 17.3342 74.6924C28.0146 69.6518 37.5015 66.3189 45.342 63.3152C49.7993 61.8904 54.4763 61.2773 59.1503 61.5047C63.0118 64.1185 66.6095 67.102 69.8924 70.4131C80.5444 67.9719 91.6108 67.9719 102.263 70.4131C105.557 67.1067 109.162 64.1236 113.026 61.5047C117.693 61.2797 122.363 61.8929 126.813 63.3152V63.3152C134.654 66.3189 144.141 69.6518 154.821 74.6924C155.766 80.9891 156.042 87.3682 155.644 93.723C157.386 96.1199 158.981 98.6209 160.418 101.212C160.978 103.926 160.978 106.727 160.418 109.441C164.642 118.928 167.563 128.942 169.103 139.211V139.211Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1733 93.8049C67.1765 85.2257 60.0975 76.7288 53.183 68.0673L52.3392 67.0181L51.0016 67.5118C42.7701 70.495 34.8473 73.8691 26.7804 77.058L25.8749 77.4077L25.6897 78.3336L21.2653 98.2488V98.6397V98.9689L23.4672 107.857L20.7714 125.262L6.36626 123.472L6.07812 125.529L21.6769 127.957L22.8498 128.122L23.0556 126.949L26.4511 108.124V107.857V107.548L24.5167 98.7425L29.0029 80.2263C36.3907 77.4077 43.8196 74.7126 51.1456 71.7294C57.9984 79.5886 64.7071 87.5505 71.4981 95.4508L69.6665 136.598L71.8274 136.721L74.5643 94.957V94.3809L74.1733 93.8049Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4997 160.979L21.5531 161.493L28.7762 175.503C25.9158 177.417 23.0759 179.371 20.3184 181.408L11.2225 187.868L11.0785 187.971V188.115L0.789062 206.631L1.73573 207.166L12.2309 189.123L21.3267 182.951C24.4547 180.894 27.5003 178.836 30.5254 176.656L31.2251 176.141L30.8136 175.421L22.4997 160.979Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1595 93.8049C104.156 85.2257 111.235 76.7288 118.17 68.0673L119.014 67.0181L120.352 67.5118C128.583 70.495 136.486 73.8691 144.552 77.058L145.458 77.4077L145.664 78.3336L150.026 98.2488V98.6397V98.9689L147.845 107.857L150.541 125.262L164.946 123.472L165.234 125.529L149.656 127.957L148.503 128.122L148.277 126.949L144.882 108.124V107.857V107.548L146.816 98.7425L142.35 80.2263C134.942 77.4077 127.513 74.7126 120.187 71.7294C113.334 79.5886 106.626 87.5505 99.8347 95.4508L101.666 136.598L99.5054 136.721L96.7891 94.957V94.3809L97.1595 93.8049Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.853 160.979L149.8 161.493L142.679 175.503C145.519 177.417 148.359 179.371 151.137 181.408L160.212 187.868L160.377 187.971V188.115L170.666 206.631L169.72 207.166L159.225 189.123L150.129 182.951C147.001 180.894 143.955 178.836 140.93 176.656L140.23 176.141L140.642 175.421L148.853 160.979Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.177 206.816L165.871 212.474L159.595 258.785L145.498 256.584L142.617 209.944L146.177 206.816Z",
    fill: "#172352"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6851 206.816L8.01172 212.474L14.2883 258.785L28.3848 256.584L31.2658 209.944L27.6851 206.816Z",
    fill: "#172352"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.082 289.543L126.321 317.235C126.116 336.353 122.994 355.328 117.06 373.504C116.115 376.211 114.478 378.624 112.312 380.504C110.146 382.384 107.527 383.666 104.713 384.222C92.3828 386.445 79.7545 386.445 67.4243 384.222C64.6105 383.666 61.9911 382.384 59.8254 380.504C57.6596 378.624 56.0228 376.211 55.077 373.504C49.1832 355.323 46.1088 336.346 45.9606 317.235L45.1992 289.563C55.9825 293.472 69.8937 295.344 86.1921 295.344C102.491 295.344 116.299 293.452 127.082 289.543Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0742 291.106C50.1965 316.868 54.363 342.451 62.4215 366.92C78.226 375.026 93.8658 375.15 109.403 366.92C116.955 344.845 120.207 319.601 120.166 292.094L50.0742 291.106Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0861 271.191C69.4585 271.191 50.3408 264.793 42.027 258.456L41.5742 246.4C49.0443 249.28 55.9794 251.708 62.3588 253.498L64.7047 262.283C78.5592 267.056 93.6131 267.056 107.468 262.283L109.752 253.457C116.069 251.667 123.066 249.342 130.536 246.359L130.084 258.415C121.811 264.793 102.714 271.191 86.0861 271.191Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M86.0886 269.195C70.1401 269.195 52.1748 263.188 43.9845 257.427L43.6758 249.342C50.0758 251.749 55.6732 253.642 60.715 255.102L63.061 263.826L64.0899 264.175C78.3446 269.085 93.8326 269.085 108.087 264.175L109.116 263.826L111.442 255.102C116.442 253.642 122.06 251.749 128.481 249.342L128.172 257.427C120.044 263.188 102.037 269.195 86.0886 269.195Z",
    fill: "url(#paint9_linear)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4723 217.947C38.4272 225.147 40.7526 231.649 44.251 235.948C51.7918 238.48 59.4824 240.541 67.2786 242.121L70.8594 251.152C80.8745 253.511 91.3008 253.511 101.316 251.152L104.876 242.121C112.68 240.544 120.377 238.483 127.924 235.948C131.402 231.649 133.727 225.168 135.703 217.967C136.197 220.189 136.65 222.452 137.061 224.798C135.858 231.133 133.722 237.255 130.723 242.964L130.579 246.379C123.109 249.26 116.174 251.687 109.794 253.477L107.469 262.262C93.6146 267.035 78.5607 267.035 64.7063 262.262L62.4221 253.457C56.125 251.667 49.1076 249.342 41.6375 246.359L41.514 242.944C38.5146 237.227 36.3787 231.098 35.1758 224.756C35.5256 222.452 35.9578 220.189 36.4723 217.947Z",
    fill: "url(#paint10_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M86.0875 263.867C79.3883 263.797 72.7368 262.729 66.3525 260.698L63.986 251.872L62.8953 251.564C57.2773 249.98 50.939 247.84 43.51 245.021V242.491L43.3042 242.1C41.2343 238.077 39.5662 233.859 38.3242 229.509C39.4468 232.269 40.9499 234.859 42.7898 237.203L43.1396 237.656L43.6952 237.841C50.9699 240.33 58.3841 242.391 65.8998 244.013L69.4805 253.066L70.5506 253.271C80.8235 255.686 91.5163 255.686 101.789 253.271L102.859 253.066L106.419 244.013C113.943 242.396 121.364 240.335 128.644 237.841L129.2 237.656L129.571 237.203C131.41 234.818 132.919 232.195 134.057 229.406C132.801 233.791 131.119 238.042 129.035 242.1L128.83 242.47L128.727 245.001C121.257 247.861 114.918 250 109.342 251.564L108.251 251.872L105.905 260.698C99.4934 262.734 92.8141 263.801 86.0875 263.867Z",
    fill: "url(#paint11_linear)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.655 177.458C116.333 183.476 118.839 190.136 120.043 197.085C115.486 193.908 110.224 191.888 104.712 191.201C92.2985 189.61 79.733 189.61 67.32 191.201C61.8577 191.912 56.6478 193.93 52.1328 197.085C53.3368 190.126 55.8657 183.463 59.5823 177.458C67.9098 173.608 76.9749 171.614 86.1495 171.614C95.3242 171.614 104.389 173.608 112.717 177.458H112.655Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.277 304.15C170.277 304.664 170.277 305.158 170.277 305.693C169.927 317.543 166.325 328.077 152.167 330.381C141.281 332.151 134.758 326.267 133.811 317.194L136.26 311.207H166.675C167.222 309.376 167.519 307.48 167.56 305.569C167.591 304.048 167.289 302.538 166.675 301.146H138.071L139.943 291.312V260.904C140.334 259.464 140.684 258.024 140.952 256.584C141.614 255.38 142.51 254.321 143.588 253.47C144.666 252.618 145.904 251.991 147.228 251.625C150.272 250.952 153.456 251.418 156.179 252.935C158.902 254.451 160.975 256.913 162.004 259.855C167.33 274.023 170.13 289.015 170.277 304.15V304.15ZM5.5434 311.227C4.99704 309.396 4.69943 307.5 4.65852 305.59C4.62724 304.069 4.92925 302.559 5.5434 301.167H34.148L32.2753 291.333V260.904C31.9049 259.464 31.555 258.024 31.2875 256.584C30.6254 255.38 29.7289 254.321 28.6509 253.47C27.573 252.618 26.3353 251.991 25.011 251.625C21.9675 250.952 18.7828 251.418 16.0598 252.935C13.3368 254.451 11.2646 256.913 10.2354 259.855C4.9229 274.025 2.13687 289.017 2.00391 304.15C2.00391 304.664 2.00391 305.158 2.00391 305.693C2.35375 317.543 5.95501 328.077 20.1132 330.381C30.9994 332.151 37.5229 326.267 38.4489 317.194L36.0206 311.207L5.5434 311.227Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8642 128.842L37.3582 146.947L32.4604 151.432C28.2285 154.297 23.1514 155.645 18.0553 155.259C8.52729 153.428 5.15239 147.358 3.15625 139.211C7.28138 142.743 12.3707 144.957 17.7671 145.568C21.705 145.869 25.6198 144.745 28.7974 142.4C31.1845 140.775 34.0038 134.706 36.8642 128.842Z",
    fill: "#172352"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9578 137.586C59.2777 135.618 72.7246 134.634 86.1892 134.644V134.644V136.578C69.4974 137.359 53.0416 140.833 37.4587 146.865L36.9648 128.76L39.1873 114.255L39.5989 99.7304L38.2819 89.4436L43.406 104.483L45.6285 106.684C43.8717 110.558 42.7263 114.68 42.233 118.905C42.2237 125.317 43.4899 131.667 45.9578 137.586V137.586Z",
    fill: "#172352"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M169.082 139.211C167.024 147.441 163.711 153.428 154.183 155.259C149.087 155.645 144.01 154.297 139.778 151.432L134.859 146.947L135.374 128.842C138.234 134.706 141.054 140.775 143.502 142.4C146.69 144.739 150.61 145.863 154.553 145.568C159.923 144.949 164.983 142.734 169.082 139.211V139.211Z",
    fill: "#172352"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.042 118.905C129.538 114.683 128.393 110.562 126.647 106.684L128.849 104.483L133.993 89.4436L132.676 99.7304L133.088 114.255L135.31 128.76L134.796 146.865C119.221 140.83 102.771 137.356 86.0859 136.578V134.644C99.5437 134.634 112.984 135.617 126.297 137.586C128.772 131.669 130.045 125.319 130.042 118.905Z",
    fill: "#172352"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3086 197.62C45.3789 201.828 40.5851 207.441 37.3561 213.955C37.0475 215.272 36.7388 216.588 36.4713 217.946C35.9568 220.189 35.5246 222.452 35.1131 224.797C33.3433 234.652 32.1291 245.371 31.2648 256.584C30.6027 255.38 29.7062 254.321 28.6283 253.47C27.5503 252.618 26.3126 251.991 24.9883 251.625C27.0462 235.454 27.7047 220.189 25.9966 206.816C31.0652 205.563 36.0104 203.855 40.7722 201.714C45.8913 191.188 50.1979 180.287 53.6545 169.105C64.1743 165.806 75.074 163.87 86.0867 163.344C97.0928 163.868 107.986 165.804 118.498 169.105C121.971 180.284 126.284 191.185 131.401 201.714C136.163 203.855 141.108 205.563 146.177 206.816C144.469 220.189 145.21 235.454 147.185 251.625C145.861 251.991 144.623 252.618 143.545 253.47C142.467 254.321 141.571 255.38 140.909 256.584C140.044 245.371 138.851 234.673 137.06 224.818C136.649 222.473 136.196 220.209 135.702 217.988C135.414 216.63 135.105 215.313 134.797 213.996C131.575 207.483 126.788 201.871 120.865 197.661L120.103 197.126C118.881 190.172 116.353 183.513 112.654 177.499C104.326 173.649 95.2614 171.655 86.0867 171.655C76.912 171.655 67.847 173.649 59.5195 177.499C55.8294 183.496 53.3217 190.145 52.1317 197.085L51.3086 197.62Z",
    fill: "#172352"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.634 301.167C167.248 302.559 167.55 304.069 167.519 305.59C167.478 307.5 167.181 309.396 166.634 311.227H136.219L133.77 317.235H126.32L127.082 289.563C132.485 280.578 136.789 270.977 139.902 260.966V291.353L138.03 301.187L166.634 301.167Z",
    fill: "#172352"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0957 289.543L45.9601 317.235H38.49L36.0617 311.248H5.54333C4.99697 309.417 4.69936 307.521 4.65845 305.611C4.62717 304.089 4.92918 302.579 5.54333 301.187H34.1479L32.2752 291.353V260.904C35.3847 270.93 39.6891 280.545 45.0957 289.543V289.543Z",
    fill: "#172352"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.579 246.4L130.723 242.985C133.722 237.276 135.858 231.154 137.061 224.818C138.81 234.673 140.045 245.392 140.909 256.584C140.642 258.024 140.292 259.464 139.901 260.904C136.788 270.916 132.484 280.517 127.08 289.502C116.297 293.411 102.386 295.283 86.0875 295.283C69.7891 295.283 55.8778 293.411 45.0946 289.502C39.6808 280.505 35.3694 270.89 32.2534 260.863C31.883 259.423 31.5331 257.983 31.2656 256.543C32.1299 245.31 33.3236 234.611 35.1139 224.757C36.3168 231.099 38.4527 237.228 41.4521 242.944L41.5756 246.359L42.0283 258.415C50.2599 264.752 69.4599 271.15 86.0875 271.15C102.715 271.15 121.812 264.752 130.126 258.415L130.579 246.4Z",
    fill: "url(#paint14_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.703 217.946C133.646 225.147 131.403 231.628 127.925 235.928C120.378 238.462 112.68 240.523 104.876 242.1L101.316 251.132C91.3012 253.491 80.8749 253.491 70.8598 251.132L67.279 242.1C59.4828 240.521 51.7922 238.459 44.2514 235.928C40.753 231.628 38.4276 225.127 36.4727 217.926C36.7402 216.568 37.0488 215.251 37.3575 213.935C40.5865 207.42 45.3803 201.808 51.3099 197.599L52.0713 197.064C56.6223 193.891 61.8768 191.872 67.382 191.18C79.795 189.589 92.3605 189.589 104.774 191.18C110.266 191.883 115.506 193.91 120.043 197.085L120.804 197.62C126.728 201.83 131.515 207.442 134.736 213.955C135.107 215.272 135.415 216.588 135.703 217.946Z",
    fill: "url(#paint15_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M70.8375 231.71C82.2953 233.232 93.8927 233.398 105.389 232.204C113.897 231.499 122.306 229.892 130.475 227.41C131.728 224.309 132.793 221.135 133.665 217.905C133.418 216.794 133.171 215.704 132.903 214.613C129.825 208.474 125.28 203.189 119.671 199.224L118.971 198.71C114.687 195.729 109.745 193.83 104.566 193.176C92.3166 191.612 79.9179 191.612 67.6684 193.176C62.4852 193.851 57.5426 195.771 53.2632 198.772L52.6253 199.224C47.0089 203.189 42.4627 208.483 39.3931 214.634C39.1462 215.704 38.8993 216.691 38.6523 217.885C39.1051 219.531 39.6401 221.279 40.2163 223.049C50.2176 226.279 60.3629 230.126 70.8375 231.71Z",
    fill: "url(#paint16_linear)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M124.448 58.1925L126.835 63.2742C122.384 61.8519 117.714 61.2387 113.047 61.4637C109.183 64.0826 105.579 67.0657 102.284 70.3722C91.6322 67.931 80.5658 67.931 69.9138 70.3722C66.6309 67.0611 63.0332 64.0775 59.1717 61.4637C54.4976 61.2363 49.8206 61.8495 45.3633 63.2742L47.7504 58.1925C49.1223 56.629 50.4943 55.1271 51.8662 53.6869C56.3743 48.6 61.6432 44.2416 67.4855 40.7667C73.0831 37.271 79.5504 35.4175 86.1504 35.4175C92.7504 35.4175 99.2177 37.271 104.815 40.7667C110.658 44.2416 115.927 48.6 120.435 53.6869C121.752 55.1957 123.089 56.6975 124.448 58.1925Z",
    fill: "url(#paint17_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0861 1.28564C107.118 1.28564 121.914 22.9497 120.37 53.6866C115.862 48.5997 110.593 44.2413 104.751 40.7664C99.1534 37.2707 92.6861 35.4172 86.0861 35.4172C79.4861 35.4172 73.0188 37.2707 67.4211 40.7664C61.5788 44.2413 56.31 48.5997 51.8018 53.6866C50.2584 23.032 65.0546 1.28564 86.0861 1.28564Z",
    fill: "url(#paint18_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M56.25 26.3856C75.2357 33.8531 96.346 33.8531 115.332 26.3856C115.332 26.3856 106.936 1.92358 85.8011 1.92358C64.6667 1.92358 56.25 26.3856 56.25 26.3856Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M86.1102 36.1785C75.3063 36.1785 65.8812 41.507 58.6992 48.2346L71.2317 60.2702C81.0261 58.048 91.1941 58.048 100.989 60.2702L113.521 48.2346C106.339 41.5481 96.914 36.1785 86.1102 36.1785Z",
    fill: "url(#paint20_linear)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M126.319 317.235C126.463 332.817 124.645 348.356 120.907 363.484C119.919 367.27 118.849 370.973 117.511 374.718C115.947 378.537 113.073 381.674 109.403 383.564C107.582 384.466 105.631 385.077 103.62 385.375C101.686 385.745 99.7517 386.012 97.7967 386.239C93.9075 386.657 89.999 386.87 86.0874 386.877C82.1755 386.88 78.2664 386.667 74.378 386.239C72.423 386.012 70.4887 385.745 68.5543 385.375C66.5432 385.08 64.5916 384.469 62.7716 383.564C59.0977 381.68 56.2211 378.541 54.6636 374.718C53.3382 371.034 52.2048 367.285 51.268 363.484C47.5548 348.353 45.7709 332.813 45.9587 317.235C46.2324 324.974 46.9194 332.693 48.0166 340.36C49.0983 347.995 50.6654 355.554 52.7086 362.991C53.7581 366.673 54.9105 370.418 56.207 373.956C57.6342 377.377 60.2407 380.173 63.5536 381.836C65.2207 382.647 67.0057 383.188 68.8423 383.441C70.7356 383.79 72.6289 384.037 74.5427 384.243C82.1951 384.956 89.8973 384.956 97.5498 384.243C99.4636 384.037 101.357 383.79 103.25 383.441C105.086 383.195 106.871 382.661 108.539 381.857C111.849 380.179 114.453 377.379 115.885 373.956C117.182 370.418 118.334 366.673 119.384 362.991C121.407 355.549 122.974 347.992 124.076 340.36C125.235 332.697 125.984 324.978 126.319 317.235V317.235Z",
    fill: "#ADFEDC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M149.284 94.7926V81.5432L152.268 75.1448L124.158 63.5824C120.461 62.7437 116.663 62.4388 112.88 62.6772L101.932 71.5444C91.2627 69.3324 80.2524 69.3324 69.5826 71.5444L58.6347 62.6772C54.8517 62.4388 51.054 62.7437 47.3575 63.5824L19.3086 75.1448L22.2926 81.5432V94.7926L13.6289 103.516L28.8983 100.142L32.4791 81.2963L38.4469 82.0575L45.2791 95.5538L83.535 96.706V96.8294H85.7575H87.98V96.706L126.236 95.5538L133.068 82.0575L139.057 81.2963L142.617 100.142L157.886 103.516L149.284 94.7926Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M133.665 149.313C119.259 135.158 52.79 135.158 38.5084 149.313C24.1032 161.657 12.5791 174.371 4.65625 187.292C16.3415 175.109 29.472 164.4 43.7559 155.403C57.6503 153.666 71.6587 153.013 85.6544 153.448H86.4364C100.432 153.013 114.44 153.666 128.335 155.403C142.619 164.4 155.749 175.109 167.434 187.292C159.594 174.371 147.987 161.739 133.665 149.313Z",
    fill: "url(#paint22_linear)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M169.101 139.212C167.317 129.024 164.21 119.113 159.861 109.73V109.586V109.441C160.052 108.078 160.162 106.704 160.191 105.327C160.255 104.017 160.116 102.705 159.779 101.438V101.562C158.357 99.0016 156.783 96.5284 155.067 94.1553L154.902 93.9496V93.6821C155.286 87.3819 155.01 81.0589 154.079 74.8161L154.49 75.3716C145.415 71.0511 135.969 67.5742 126.544 64.015H126.256L126.133 63.7475L123.746 58.6452L123.849 58.8304C119.012 52.9451 113.422 47.7225 107.221 43.2974C104.066 41.2293 100.665 39.5636 97.0961 38.3391C89.9937 35.6224 82.1381 35.6224 75.0357 38.3391C71.4673 39.5636 68.066 41.2293 64.9109 43.2974C58.7101 47.7225 53.1194 52.9451 48.2833 58.8304L48.3861 58.6452L45.9578 63.6035L45.8344 63.871H45.5462C36.1006 67.4302 26.6755 70.9071 17.6003 75.2276L18.0119 74.6721C17.0804 80.9149 16.8044 87.2379 17.1887 93.5381V93.785L17.0241 94.0113C15.3075 96.3843 13.7338 98.8576 12.3115 101.418V101.294C11.9773 102.562 11.8317 103.872 11.8794 105.183C11.9183 106.559 12.0282 107.932 12.2087 109.297V109.483V109.627C7.82012 118.995 4.71224 128.912 2.96875 139.109C4.3105 128.8 7.03067 118.718 11.0563 109.133V109.462C10.8171 108.066 10.6522 106.658 10.5623 105.244C10.4266 103.765 10.5591 102.274 10.9533 100.842V100.842C12.408 98.2321 14.016 95.7108 15.7688 93.2912L15.6247 93.7644C15.2364 87.361 15.5192 80.9344 16.4685 74.5898V74.1989L16.8389 74.0137C25.9759 69.6727 35.4833 66.1546 44.8878 62.6159L44.4762 63.0068L46.8633 57.9046C51.7951 51.9217 57.4889 46.6097 63.7997 42.104C67.0699 39.9771 70.5874 38.2568 74.2743 36.9812C81.688 34.1837 89.8676 34.1837 97.2813 36.9812C100.968 38.2568 104.486 39.9771 107.756 42.104C114.067 46.6097 119.76 51.9217 124.692 57.9046V57.9046L127.079 63.0068L126.668 62.6159C136.072 66.1546 145.58 69.6727 154.717 74.0137L155.087 74.1989V74.5898C156.036 80.9344 156.319 87.361 155.931 93.7644L155.787 93.2912C157.735 95.6875 159.542 98.1948 161.199 100.801V100.924C161.598 102.362 161.737 103.86 161.611 105.347C161.519 106.768 161.355 108.182 161.117 109.586V109.236C165.128 118.819 167.815 128.903 169.101 139.212V139.212Z",
    fill: "#ADFEDC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.113 53.7073H119.631C120.496 36.1169 115.907 20.6867 107.037 11.3462C104.383 8.42863 101.149 6.09758 97.5412 4.50247C93.9336 2.90736 90.0325 2.0834 86.0879 2.0834C82.1432 2.0834 78.2421 2.90736 74.6346 4.50247C71.027 6.09758 67.7926 8.42863 65.1387 11.3462C56.2692 20.6867 51.6802 36.0346 52.5445 53.7073H51.0628C50.1573 35.726 54.8905 19.8843 64.048 10.2352C66.8491 7.18077 70.2549 4.74191 74.049 3.07347C77.8432 1.40502 81.9429 0.543457 86.0879 0.543457C90.2328 0.543457 94.3326 1.40502 98.1267 3.07347C101.921 4.74191 105.327 7.18077 108.128 10.2352C117.285 19.8843 122.101 35.726 121.113 53.7073Z",
    fill: "#ADFEDC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 86.0868,
    y1: 131.393,
    x2: 86.0868,
    y2: 259.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 86.0879,
    y1: 62.1014,
    x2: 86.0879,
    y2: 163.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1EBCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#20929E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#21708A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21587C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#224A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 6.11928,
    y1: 101.829,
    x2: 74.5643,
    y2: 101.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E74552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE7267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EC6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E84954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E63A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 12815.9,
    y1: 16615.8,
    x2: 13266,
    y2: 16615.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E74552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE7267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EC6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E84954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E63A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 32107.8,
    y1: 22114.2,
    x2: 34384.3,
    y2: 22114.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E74552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE7267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EC6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E84954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E63A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15015.8,
    y1: 16615.8,
    x2: 15466,
    y2: 16615.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E74552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE7267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EC6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E84954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E63A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 86.0893,
    y1: 388.584,
    x2: 86.0893,
    y2: 306.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3694AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#264175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#222B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 32432.4,
    y1: 37683.5,
    x2: 32432.4,
    y2: 34800.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3694AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#264175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#222B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 41.5742,
    y1: 258.806,
    x2: 130.577,
    y2: 258.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF964F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF18E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFB464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF9A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF8B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 86.0886,
    y1: 277.137,
    x2: 86.0886,
    y2: 237.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BC18A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7A0F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#45093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#20041C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#080108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 44633.5,
    y1: 18628.5,
    x2: 49680.9,
    y2: 18628.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5354A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E74552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EE7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE7267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EC6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E84954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E63A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5354A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 44315.5,
    y1: 14094.4,
    x2: 44315.5,
    y2: 13052.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BC18A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7A0F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#45093E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#20041C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#080108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 31460.5,
    y1: 8863.26,
    x2: 31460.5,
    y2: 9632.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 77828.1,
    y1: 29747,
    x2: 77828.1,
    y2: 34256.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 50741.5,
    y1: 26806.8,
    x2: 50741.5,
    y2: 29569.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3694AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2D658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#264175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#222B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 45930.7,
    y1: 22593.6,
    x2: 45930.7,
    y2: 24777.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 86.0864,
    y1: 174.536,
    x2: 86.0864,
    y2: 250.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E705E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#09483C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#02120F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 37725.9,
    y1: 9833.56,
    x2: 37725.9,
    y2: 10664.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 31866.8,
    y1: 13806.9,
    x2: 31866.8,
    y2: 16454.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1DDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FB6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#20939F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#21778E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#216181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#225177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#224872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 27375.6,
    y1: 8041.58,
    x2: 27375.6,
    y2: 8644.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E705E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#09483C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#02120F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 25414.3,
    y1: 6881.83,
    x2: 25414.3,
    y2: 7268.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E705E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#09483C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#02120F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 66713.9,
    y1: 12241.6,
    x2: 66713.9,
    y2: 13296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E705E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#09483C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#02120F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 75289.6,
    y1: 16404.4,
    x2: 75289.6,
    y2: 17890.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139B82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E705E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#09483C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#052922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#02120F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenbike);
export default __webpack_public_path__ + "static/media/greenbike.74a5c6dd745eda09c1ae60fa6995b3ef.svg";
export { ForwardRef as ReactComponent };